import type { ProgressSheetParams } from "@api/progress"

export const gradingKeys = {
  all: ["grading"] as const,
  uploads: () => [...gradingKeys.all, "upload"] as const,
  upload: (id: string) => [...gradingKeys.uploads(), id] as const,
}

// The ProgressRecord cache branch. Lived in `features/progress` until
// PRD-58 retired that feature; grading is where every grade write happens,
// so its invalidation namespace lives here now.
export const progressKeys = {
  all: ["progress"] as const,
  sheets: () => [...progressKeys.all, "sheet"] as const,
  sheet: (params: ProgressSheetParams) => [...progressKeys.sheets(), params] as const,
}
